import { HttpErrorResponse } from '@angular/common/http'
import { ErrorHandler, Injectable } from '@angular/core'

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  handleError(error: HttpErrorResponse): void {
    console.error('ERROR :', error)
  }
}
